import React, { Component } from 'react'
import {Button,Icon,notification,Alert} from 'antd';

class NotificationBanner extends Component {
    constructor(props) {
        super(props);
        notification.config({
            placement: "bottomLeft",
        });

        this.state ={
            key: "notification"
        }
    }

    componentWillReceiveProps(nextProps) {
        if(this.props !== nextProps){
            this.setState({
                visible: nextProps.visible
            })
            /*
            if(nextProps.visible) {
                notification.open({
                    message: "エラー",
                    description: '状態取得に失敗しました。最新の状態でない可能性があります。数十秒後に再同期します。',
                    icon: <Icon type="warning" style={{color: 'red'}}/>,
                    key: this.state.key
                });
            }else{
                notification.close(this.state.key)
            }
            */
        }
    }

    render() {
        return(
            <div className={"notification-banner"}>
                {this.state.visible ?
                    <Alert type="error" message="エラー (状態取得に失敗しました。最新の状態でない可能性があります。一定時間毎に再同期します。)" banner />
                    :
                    undefined
                }
            </div>
        )
    }
}

export default NotificationBanner


// WEBPACK FOOTER //
// ./src/components/NotificationBanner.js